import { useState, useCallback } from 'react';
import HomeComp from '../component/home';
import { WingHome } from './wing/index';
import Head from 'next/head';

const themeColors = {
  0: '#8149f9',
  1: '#fd66ca',
  2: '#0a98fb',
};

export default function (props) {
  const [activeIndex, setActiveIndex] = useState(0);

  // 处理索引变化的回调函数
  const handleIndexChange = useCallback((index) => {
    setActiveIndex(index);
  }, []);

  if (props.isWing) {
    return (
      <>
        <Head>
          <title>Wing - Meet People You Resonate With</title>
          <meta name="theme-color" content="#f3ddf8" />
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <meta name="apple-mobile-web-app-status-bar-style" content="#f3ddf8" />
          <link
            rel="icon"
            type="image/x-icon"
            href="https://cdn.duetapp.net/v1/images/eyJpZCI6Ik5EMzdJTElGRjU1VkZKMzNPUkhQS01KVjZYV0dPNCIsInciOjY0LCJoIjo2NCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjk2ODc3ODg2MDg5OTAzNzYzNTB9.png"
          />
        </Head>
        <WingHome showLoginEntry />
      </>
    );
  }

  return (
    <>
      <Head>
        <meta name="theme-color" content={themeColors[activeIndex]} />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content={themeColors[activeIndex]} />
      </Head>
      <HomeComp onIndexChange={handleIndexChange} />
    </>
  );
}

export async function getServerSideProps(context) {
  const host = context.req?.headers?.host || '';

  return {
    props: {
      omiEnv: process.env.OMI_ENV || '',
      nodeEnv: process.env.NODE_ENV || '',
      isWing: host.includes('wingapp.ai'),
    },
  };
}
